import { axiosClient } from "@/shared/api/axios-client";
import type { SolicitudDetalle } from "@/lib/types";

/** Posición (concepto) de la consulta estilo ME23N de la orden de compra. */
export interface ConsultaOrdenConcepto {
  lineaPedido: string;
  descripcion: string;
  cantidad: number;
  unidad: string | null;
  valorUnitario: number;
  importe: number;
  cuentaContable: string | null;
  centroCostos: string | null;
}

/** Entrada de almacén (recepción o anulación) de la orden de compra. */
export interface ConsultaEntrada {
  folio: string | null;
  fecha: string | null;
  referencia: string | null;
  esAnulacion: boolean;
  anula: string | null;
  subTotal: number;
  impuestos: number;
  total: number;
}

/** Conciliación por línea · pedido (OC) vs recibido neto (entradas). */
export interface ConsultaConciliacionLinea {
  lineaPedido: string;
  descripcion: string;
  cantidadPedida: number;
  importePedido: number;
  cantidadRecibida: number;
  importeRecibido: number;
}

/** Consulta (solo lectura) de la OC · cabecera + posiciones + entradas + conciliación. */
export interface ConsultaOrden {
  clave: string;
  proveedorNombre: string;
  proveedorRfc: string;
  proveedorClave: string | null;
  moneda: string;
  estatus: string | null;
  fecha: string | null;
  subTotal: number;
  impuestos: number;
  total: number;
  recibidoNeto: number;
  facturado: number;
  disponible: number;
  version: number;
  esUltimaVersion: boolean;
  conceptos: ConsultaOrdenConcepto[];
  entradas: ConsultaEntrada[];
  conciliacion: ConsultaConciliacionLinea[];
}

/**
 * Orden de Compra (OC) · asocia la OC a la solicitud por su clave en SAP. El backend
 * busca la OC, deriva el proveedor y devuelve el detalle actualizado de la solicitud.
 */
export const ordenCompraApi = {
  seleccionar: (id: string, clave: string) =>
    axiosClient
      .patch<SolicitudDetalle>(`/api/solicitudes/${id}/orden-compra`, { clave })
      .then((r) => r.data),

  consultar: (clave: string) =>
    axiosClient
      .get<ConsultaOrden>(`/api/solicitudes/consulta/orden-compra/${encodeURIComponent(clave)}`)
      .then((r) => r.data),
};
